import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { GetHodIndentList } from "../../Repository/Api";
import { Link } from "react-router-dom";
import moment from "moment";
import { errorMsg } from "../Toastify";

const HodIndentformrequest = () => {
  const { first_name, access_token, department } = useSelector((state) => state?.auth?.auth);
  const token = access_token
  const [indentList, setIndentList] = useState([]);

  useEffect(() => {
    getIndentList();
  },[]);

  const [active, setActive] = useState(0);
  const links = ["Pending", "Approved", "Rejected"];
  const showSelected = (index) => {
    setActive(index);
  };

  const getIndentList = async () => {
    const response = await GetHodIndentList(token);
    if (response && response.statusCode === 200) {
      setIndentList(response?.data?.purchase_history);
    } else {
      errorMsg(response.message);
    }
  };

  const pendingLeaveLength = indentList.filter(
    (item) => item.hod_status === "pending"
  ).length;
  const approveLeaveLength = indentList.filter(
    (item) => item.hod_status === "approved"
  ).length;
  const rejectLeaveLength = indentList.filter(
    (item) => item.hod_status === "rejected"
  ).length;

  return (
    <>
      <div className="">
        <section className="top-content-container">
          <div className="my-4">
            <div className="row">
              <div className="col-lg-6">
                <h6 className="headertext">{first_name}</h6>
                <h6 className="subheadertext">{department}</h6>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="row">
            <div className="">
              <div className="graphbox">
                <div className="row">
                  <div className="col-lg-3 p-0">
                    <h6 className="labeltitle">Indent Form Request</h6>
                  </div>
                  <div className="col-lg-4 p-0">
                    <ul className="searchtopflex">
                      {links.map((link, index) => {
                        return (
                          <li
                            onClick={() => showSelected(index)}
                            key={link}
                            className={
                              active === index
                                ? "agenttextactive"
                                : "agenttextinactive"
                            }
                          >
                            {link}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
                <table className="table table-hover mt-5">
                  <thead>
                    <tr>
                      <th scope="col">Indent No</th>
                      <th scope="col">Name</th>
                      <th scope="col">Department</th>
                      <th scope="col">Date</th>
                      <th scope="col">Application</th>
                    </tr>
                  </thead>
                  {active === 0 && (
                    <tbody>
                      {pendingLeaveLength > 0 ? (
                        indentList &&
                        indentList
                          ?.filter(
                            (indentList) => indentList.hod_status === "pending"
                          )
                          .map((indent, index) => (
                            <tr key={index}>
                              <td>
                                {indent?.indent_number
                                  ? indent?.indent_number
                                  : "-"}
                              </td>
                              <td>
                                {indent?.employee_name
                                  ? indent?.employee_name
                                  : "-"}
                              </td>
                              <td>
                                {indent?.department ? indent?.department : "-"}
                              </td>
                              <td>
                                {moment(indent?.requested_date).format(
                                  "DD MMM YY"
                                )}
                              </td>
                              <td className="viewoption">
                                <Link
                                  to={`/app/Hod/HodIndentspecificsview/${indent?.id}`}
                                >
                                  View
                                </Link>
                              </td>
                            </tr>
                          ))
                      ) : (
                        <tr>
                          <td></td>
                          <td></td>
                          <td>
                            <div> No Data Found</div>
                          </td>
                          <td></td>
                          <td></td>
                        </tr>
                      )}
                    </tbody>
                  )}
                  {active === 1 && (
                    <tbody>
                      {approveLeaveLength > 0 ? (
                        indentList &&
                        indentList
                          ?.filter(
                            (indentList) => indentList.hod_status === "approved"
                          )
                          .map((indent, index) => (
                            <tr key={index}>
                              <td>
                                {indent?.indent_number
                                  ? indent?.indent_number
                                  : "-"}
                              </td>
                              <td>
                                {indent?.employee_name
                                  ? indent?.employee_name
                                  : "-"}
                              </td>
                              <td>
                                {indent?.department ? indent?.department : "-"}
                              </td>
                              <td>
                                {moment(indent?.requested_date).format(
                                  "DD MMM YY"
                                )}
                              </td>
                              <td className="viewoption">
                                <Link
                                  to={`/app/Hod/HodIndentspecificsview/${indent?.id}`}
                                >
                                  View
                                </Link>
                              </td>
                            </tr>
                          ))
                      ) : (
                        <tr>
                          <td></td>
                          <td></td>
                          <td>
                            <div> No Data Found</div>
                          </td>
                          <td></td>
                          <td></td>
                        </tr>
                      )}
                    </tbody>
                  )}
                  {active === 2 && (
                    <tbody>
                      {rejectLeaveLength > 0 ? (
                        indentList &&
                        indentList
                          ?.filter(
                            (indentList) => indentList.hod_status === "rejected"
                          )
                          .map((indent, index) => (
                            <tr key={index}>
                              <td>
                                {indent?.indent_number
                                  ? indent?.indent_number
                                  : "-"}
                              </td>
                              <td>
                                {indent?.employee_name
                                  ? indent?.employee_name
                                  : "-"}
                              </td>
                              <td>
                                {indent?.department ? indent?.department : "-"}
                              </td>
                              <td>
                                {moment(indent?.requested_date).format(
                                  "DD MMM YY"
                                )}
                              </td>
                              <td className="viewoption">
                                <Link
                                  to={`/app/Hod/HodIndentspecificsview/${indent?.id}`}
                                >
                                  View
                                </Link>
                              </td>
                            </tr>
                          ))
                      ) : (
                        <tr>
                          <td></td>
                          <td></td>
                          <td>
                            <div> No Data Found</div>
                          </td>
                          <td></td>
                          <td></td>
                        </tr>
                      )}
                    </tbody>
                  )}
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default HodIndentformrequest;
